import { Passport } from "./passport";

export class MigratoryForm {
  public static firstMrzLine({ expedition_country, passport_number }): string {
    let mrz_first_line = `I<${expedition_country}`;
    let parsed_migration_number = Passport.fillMrzLine(Passport.parseString(passport_number), 9);
    let check_digit = Passport.calculateCheckDigit(parsed_migration_number);
    mrz_first_line += parsed_migration_number + check_digit;
    mrz_first_line = Passport.fillMrzLine(mrz_first_line, 30);
    return mrz_first_line;
  }

  public static secondMrzLine({ birthdate, expiry_date, genre, nationality, passport_number }): string {
    let parsed_migration_number = Passport.fillMrzLine(Passport.parseString(passport_number), 9);
    let check_digit = Passport.calculateCheckDigit(parsed_migration_number);
    let parsed_birthdate = Passport.parseDate(birthdate?.toDate());
    let parsed_expiry_date = Passport.parseDate(expiry_date?.toDate());
    let birthdate_check_digit = Passport.calculateCheckDigit(parsed_birthdate);
    let second_mrz_line = `${parsed_birthdate}${birthdate_check_digit}${genre}`;
    let expiry_date_check_digit = "0";
    if (parsed_expiry_date) {
      expiry_date_check_digit = Passport.calculateCheckDigit(parsed_expiry_date);
      second_mrz_line += parsed_expiry_date + expiry_date_check_digit + nationality;
    } else {
      second_mrz_line = Passport.fillMrzLine(Passport.parseString(second_mrz_line), 14);
      second_mrz_line += expiry_date_check_digit + nationality;
    }
    let string_for_last_digit =
      parsed_migration_number +
      check_digit +
      parsed_birthdate +
      birthdate_check_digit +
      parsed_expiry_date +
      expiry_date_check_digit;
    let last_check_digit = Passport.calculateCheckDigit(string_for_last_digit);
    second_mrz_line = Passport.fillMrzLine(Passport.parseString(second_mrz_line), 29);
    second_mrz_line += last_check_digit;
    return second_mrz_line;
  }

  public static thirdMrzLine({ first_name, middle_name, first_last_name, second_last_name }): string {
    first_name = Passport.parseString(first_name);
    middle_name = Passport.parseString(middle_name);
    first_last_name = Passport.parseString(first_last_name);
    second_last_name = Passport.parseString(second_last_name);

    let count_validation = this.nameCountValidation(first_name, middle_name, first_last_name, second_last_name);
    if (!count_validation && second_last_name.length > 3) {
      second_last_name = second_last_name.substring(0, 3);
      count_validation = this.nameCountValidation(first_name, middle_name, first_last_name, second_last_name);
      if (!count_validation) {
        middle_name = middle_name.substring(0, 3);
      }
    }
    let mrz_third_line = first_last_name.replace(" ", "<");
    if (second_last_name != "") {
      mrz_third_line += "<" + second_last_name.replace(" ", "<");
    }
    mrz_third_line += "<<" + first_name.replace(" ", "<");
    if (middle_name != "") {
      mrz_third_line += "<" + middle_name.replace(" ", "<");
    }
    mrz_third_line = Passport.fillMrzLine(Passport.parseString(mrz_third_line), 30);
    return mrz_third_line;
  }

  private static nameCountValidation(first_name, middle_name, first_last_name, second_last_name) {
    console.log(first_name.length + middle_name.length + first_last_name.length + second_last_name.length);
    if (first_name.length + middle_name.length + first_last_name.length + second_last_name.length <= 27) {
      return true;
    } else {
      return false;
    }
  }
}
